// services/api.js
import axios from "axios";
import config from "../configuration/config";
import i18n from "../i18n";
import { installAliasInterceptor } from "../utils/apiResponseNormalizer";
// إنشاء نسخة مخصصة من axios بإعدادات ثابتة
const api = axios.create({
  baseURL: config.controllURL, // <-- ضع رابط الـ API الأساسي هنا
  // timeout: 10000, // 10 ثوانٍ كحد أقصى للانتظار
  headers: {
    "Content-Type": "application/json"
  }
});


// مثال: إضافة اللغة كـ query أو header تلقائيًا
api.interceptors.request.use(request => {
  const lang = (i18n.language || 'ar');
  request.url = `${lang}/${request.url}`; // نفس أسلوبك في `lang + "/api/..."`
  return request;
});

// Add camelCase aliases on every response so newer UI code (which reads
// `offer.title`, `car.brandID`, etc.) works alongside the ~242 existing
// PascalCase readers (`response.data.ApiObjectData`, etc.). Applied to both
// the shared `api` instance and the default `axios` (which many pages still
// call directly via `axios.request({...})`).
installAliasInterceptor(api);
installAliasInterceptor(axios);

// يمكنك أيضاً إضافة Interceptors هنا (مثلاً لإضافة التوكن تلقائياً)
// api.interceptors.request.use(config => {
//     const token = localStorage.getItem("authToken");
//     if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
// });

export default api;
